module.exports = __webpack_public_path__ + "img/gear-F_48x48.706649b5.png";